export default __webpack_public_path__ + "static/media/whisper-oval-carbon-mtb.65171ddc.jpg";